// extracted by mini-css-extract-plugin
module.exports = {"files":"DriverDetails_files__r6FDX"};